import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  ImageButtonPlatformProps,
  ImageButtonDefinition,
  ImageButtonCarmiProps,
  ImageButtonStateValues,
} from '../ImageButton.types';

export const props = withCompInfo<
  ImageButtonPlatformProps,
  ImageButtonDefinition,
  ImageButtonCarmiProps
>()(
  [
    'compData',
    'fullNameCompType',
    'language',
    'compId',
    'mainPageId',
    'trackClicksAnalytics',
  ],
  (compProps, carmiData) => {
    return {
      ...carmiData,
      ...compProps,
      a11y: compProps.compData?.a11y,
    };
  },
);

const stateRefs = withStateRefsValues<keyof ImageButtonStateValues>([
  'reportBi',
  'reducedMotion',
]);

export default createComponentMapperModel({
  props,
  stateRefs,
});
